/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Classes } from "@blueprintjs/core";
var NS = Classes.getClassNamespace();
export var MULTISELECT = NS + "-multi-select";
export var MULTISELECT_POPOVER = MULTISELECT + "-popover";
export var MULTISELECT_TAG_INPUT_INPUT = MULTISELECT + "-tag-input-input";
export var OMNIBAR = NS + "-omnibar";
export var OMNIBAR_OVERLAY = OMNIBAR + "-overlay";
export var SELECT = NS + "-select";
export var SELECT_POPOVER = SELECT + "-popover";
export var SELECT_MATCH_TARGET_WIDTH = SELECT + "-match-target-width";
//# sourceMappingURL=classes.js.map